import StringValue from '../../../framework/value/StringValue';

export default class StoragePath extends StringValue {}